import { RootState } from '@redux/types';

export const searchInputValueSelector = (state: RootState) => state.search.inputValue;

export const suggestionRequestSelector = (state: RootState) => state.search.suggestSong;
